import {Component, OnInit} from '@angular/core';
import {DomSanitizer} from '@angular/platform-browser';
import {InputText} from 'primeng/inputtext';
import {TableModule} from 'primeng/table';
import {ConfirmationService} from 'primeng/api';
import {UsersService} from './users.service';

@Component({
	selector: 'manage-users-component',
	templateUrl: 'manage-users.component.html',
	styleUrls: ['manage-users.component.css'],
	providers: [ConfirmationService]
})
export class ManageUsersComponent implements OnInit {
	usersService: UsersService;
	confirmationService: ConfirmationService;

	// the following are used by manage-users.component.html
	//   users: to display the table of users
	//   selectedUsers: users which have been selected in the table
	users: any[];
	cols: any[];
	selectedUsers: any;
	editButtonPath;

	constructor(usersService: UsersService, confirmationService: ConfirmationService, private sanitization: DomSanitizer) {
		this.usersService = usersService;
		this.confirmationService = confirmationService;
		// this works but still gets unsanitized warning
		this.editButtonPath = this.sanitization.bypassSecurityTrustUrl('assets/images/EditIcon/Edit_Icon_32.png');
		// this.editButtonPath = this.sanitization.bypassSecurityTrustUrl('url(../assets/images/EditIcon/Edit_Icon_32.png)');
	}

	ngOnInit() {
		this.fillTableWithUsers();

		this.cols = [
			{ field: 'username', header: 'User Name'},
			{ field: 'name', header: 'Name'},
			{ field: 'email', header: 'Email'},
			{ field: 'rolesString', header: 'Roles'},
			{ field: 'username', header: ''},
			{ field: 'username', header: ''}
		];
	}

	fillTableWithUsers() {
		this.usersService.queryForUsers().subscribe(users => {
			console.log ( users );
			this.users = users.users;

			this.users.forEach(function(element) {
				const roles = element.roles;
				let rolesString = '';
				roles.forEach(function(role, index) {
					if ( index > 0 ) {
						rolesString += ', ';
					}
					rolesString += role.name;
				});
				element['rolesString'] = rolesString;
			}, this);
		});
	}

	//
	// add user is defined in the manage-users-add component
	// edit user is defined in the manage-users-add component
	//

	//
	// delete user
	//
	deleteUser(username) {
		console.log(username);

		// first verify the desired deletion
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete ' + username,
			header: 'Delete Confirmation',
			icon: 'fa fa-trash',
			accept: () => {

				this.usersService.deleteUser(username)
					.subscribe (() => this.fillTableWithUsers());

				// clear out selectedUser because DataTable holds onto previously selected users otherwise
				this.selectedUsers = null;
				}
			});
	}

}
